export const semanthicPathsBreadcrumbIgnore = [
  '/',
  '/hub',
  '/hub/company',
  '/hub/startup',
  '/hub/idea'
]
